import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from 'dompurify';
import React, { useMemo } from 'react';
import { JSDOM } from 'jsdom';
let DOMPurifyServer;
if (!__CLIENT__) {
    const { window } = new JSDOM('');
    DOMPurifyServer = DOMPurify(window);
}
export const SafeHtmlWrapper = ({ html, className })=>{
    const sanitize = __CLIENT__ ? DOMPurify.sanitize : DOMPurifyServer.sanitize;
    const sanitizedHtml = useMemo(()=>sanitize(html, {
            ADD_ATTR: [
                'target'
            ]
        }), [
        html
    ]);
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        dangerouslySetInnerHTML: {
            __html: sanitizedHtml
        }
    });
};
